<template>
    <div class="row justify-content-center">
        <div class="col-12 col-md-10 mb-4" v-for="index in 2" :key="index">
            <b-card no-body variant="light" class="shadowed h-100">
                <div class="row mx-0">
                    <div class="col-12 col-md-4 p-4 d-flex order-0">
                        <b-skeleton-img animation="fade" width="100%" :height="isMobile ? '165px' : '100%'" no-aspect />
                    </div>
                    <div class="col-12 col-md-8 pt-md-4 pb-4 px-4">
                        <b-skeleton animation="fade" height="11px" width="150px" />
                        <b-skeleton animation="fade" height="19px" width="300px" class="mb-3" />
                        <b-skeleton animation="fade" height="14px" width="100%" />
                        <b-skeleton animation="fade" height="14px" width="100%" />
                        <b-skeleton animation="fade" height="14px" width="100%" />
                        <b-skeleton animation="fade" height="14px" width="100%" v-if="isMobile" />
                        <b-skeleton animation="fade" height="14px" width="50%" />
                        <b-skeleton animation="fade" class="mt-3" height="10px" />
                        <b-skeleton animation="fade" height="11px" width="100px" />
                        <b-skeleton type="button" animation="fade" class="mt-3 ml-auto" />
                    </div>
                </div>
            </b-card>
        </div>
    </div>
</template>

<script>
    import mobileCheckMixin from "../../mixins/mobileCheckMixin";

    export default {
        name: "ActiveServicesSkeleton",
        mixins: [mobileCheckMixin]
    }
</script>